import { render, staticRenderFns } from "./RuleInfoDialog.vue?vue&type=template&id=35669ebf&scoped=true&"
import script from "./RuleInfoDialog.vue?vue&type=script&lang=js&"
export * from "./RuleInfoDialog.vue?vue&type=script&lang=js&"
import style0 from "./RuleInfoDialog.vue?vue&type=style&index=0&id=35669ebf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35669ebf",
  null
  
)

export default component.exports